export default __webpack_public_path__ + "static/media/emailblock.79da8b6a.svg";